export default __webpack_public_path__ + "static/media/320x320.2b905074.jpg";